module.exports = __webpack_public_path__ + "static/media/Sunflora_gaussian2.9314655d.png";